// extracted by mini-css-extract-plugin
export default {"background":"WaveLayout_background__4QfZK","aligner":"WaveLayout_aligner__ksMAr"};